export default {
    apiBaseUrl: process.env.VUE_APP_API_BASE_URL || window._config.apiBaseUrl,
    iam: {
        url: process.env.VUE_APP_IAM_URL || window._config.iam.url,
        realm: process.env.VUE_APP_IAM_REALM || window._config.iam.realm,
        clientId: process.env.VUE_APP_IAM_CLIENT_ID || window._config.iam.clientId
    }
}